import React, { useEffect, useState } from "react";
import { Button, Checkbox, IconListView, IconPlus, IconTrash, InlineNotification, RadioButton, RadioButtons, Select, Table, TextArea, TextBox, Modal, ConfirmationModal } from "@veneer/core";
import { Row, Col, Container } from 'react-bootstrap';
import Swal from "sweetalert2";
import ConnectAPI from '../../../services/api';
import { useTranslation } from "react-i18next";

const NewSpecialCondition = ({boolevergreen=false,...props}) => {
    const [t, i18n] = useTranslation();
    const connectApi = new ConnectAPI();

    const [scenario, setScenario] = useState(0)
    const [channelList, setChannelList] = useState([])
    const [channel, setChannel] = useState("")
    const [endUserList, setEndUserList] = useState([])
    const [endUser, setEndUser] = useState("")
    const [pressList, setPressList] = useState([])
    const [seriesList, setSeriesList] = useState ([])
    const [series, setSeries] = useState(0)
    const [pressListBySeries, setPressListBySeries] = useState ([])
    const [specialConditionTypeList, setSpecialConditionTypeList] = useState ([])
    const [specialConditionType, setSpecialConditionType] = useState("")

    const[newEndUser, setNewEndUser] = useState("")
    const[newPress, setNewPress] = useState("")
    const[opdNumber, setOpdNumber] = useState("")
    const[validFromList,setValidFromList] = useState([])

    const [oneShotDisabled, setOneShotDisabled] = useState(false)
    const [whiteDisabled, setWhiteDisabled] = useState(false)
    const [multiplierConfig, setMultiplierConfig] = useState(1)
    
    const [selectedPress, setSelectedPress] = useState(false)
    const [showModalSegment, setShowModalSegment] = useState(false)
    const [showMessage, setShowMessage] = useState("")
    const [newPressSegment, setNewPressSegment] = useState("")
    const [segmentSelected, setSegmentSelected] = useState("")
    const [showModalSegmentNotSelected, setShowModalSegmentNotSelected] = useState(false)


    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    const clearForm = () => {
        setChannel("");
        setEndUserList([]);
        setEndUser("");
        setPressList([]);
        setSeriesList([]);
        setSeries("");
        setSpecialConditionTypeList([]);
        setSpecialConditionType(0);
        setNewEndUser("");
        setNewPress("");
        setSubmitBtn(false);
        setNewPressSegment("");
        setPressListBySeries([]);
        setPercentage("");
        setMinimumImp(0);
        setStartDate("");

        setEndDate("");
        setSelectedPress(false);
        setMinPrint(1);
        setMaxPrint("");
        setBonus("");
        setIsLastTier(false);
        setBlackCpp("");
        setOtherCpp("");
        setOneShotCpp("");
        setWhiteCpp("");
        setBonusLS("");
        setIsLastTierLS(false);
        setIsAddOneMin(false);
        setBonusTable([]);
        setCompensationTable([]);
        setCombineClicksList([]);
        setBonusLSDiscountSend([]);

        setBusinessJustification("");
        setvolumeGrowth(0);
        setCompetition("");
        setBusinessOpportunities("");
        setComments("");
        setEndUserContactName("");
        setEndUserContactPhone("");
        setEndUserContactPosition("");
    }

    useEffect(() => {
        //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
        const fetchData = () => {
            connectApi
            .get("api/Channels","",ChannelListData)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                  );
            });
        };
        const ChannelListData = (status, data) => {
            const items = data.map((item) => {
                if (item.type != "Inactive"){
                    return{
                        value: item.idCustomer,
                        label: item.name,
                    };
                }
            });
            let channels = items.filter(x => x)
            setChannelList(channels);
        };
        fetchData();
        const currentDate = new Date();
        currentDate.setDate(1);
        currentDate.setMonth(currentDate.getMonth()-1);
        let DateList = []
        for (let i = 0; i <= 3; i++){
            DateList.push({value : (new Date(currentDate)).toString(), label: t('month' + (new Date(currentDate).getMonth()+1).toString()) + ' ' + new Date(currentDate).getFullYear() });
            currentDate.setMonth(currentDate.getMonth()+1);
        }
        setValidFromList(DateList);
    },[]);

    const fetchEndUsers = (channel) => {
        connectApi
        .get("api/Channels/endUsers",
        {
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListData)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
              );
        });
    };
    const EndUserListData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        setEndUserList(items);
    };

    const fetchPress = (endUser) => {
        connectApi
        .get("api/Channels/endUsers/" + endUser + "/ActivePresses",
        {
            params:{
                endUserId: endUser
            }
        },PressListData)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
              );
        });
    };
    const PressListData = (status, data) => {
        for (let i = 0; i < data.length; i++){
            if (scenario==2){
                if (newPress.charAt(0) == data[i].idPress.charAt(0)){
                    Object.assign(data[i],{uid:i, rowConfig:{ selected:false }});
                } else{
                    delete(data[i]);
                }
            }else{
                Object.assign(data[i],{uid:i, rowConfig:{ selected:false }});
            }
           
        }
   
        if (data.length>0){
            let array=[];
            for (let i = 0; i < data.length; i++){
                if (data[i]!=undefined){
                    array.push(data[i]);
                }
            }
            setPressList(array);
            
            //setPressList(data);
        }else{
            setPressList([]);
        }
        
    };
    const configpress=(status,data)=>{
        if (data.length>0){
            setSeries([4]);
            setSpecialConditionType(0);
            fetchSpConditions(4);
    
            setOneShotDisabled(!data[0].oneShotVisible);
            setWhiteDisabled(!data[0].whiteVisible);
            setMultiplierConfig(data[0].multiplier);
            setWhiteCpp("");
        }else{
            Swal.fire(
                "Error ",
                t("Error_S4"),
                "error"
            );            
        }
        
        
    }
    const PressListData2 = (status, data) => {
        let array=[];
        for (let i = 0; i < data.length; i++){
            if (data[i].idPress.charAt(0)===newPress.charAt(0)){
                array.push(
                    {
                        "classification":data[i].classification,
                        "idPress":data[i].idPress,
                        "series":data[i].series,
                        "segment":data[i].segment
                    }
                );
            }
        }
        setPressList(array);
    };

    useEffect(() => {
        const getSeriesList = () => {
            let items = [], AvailableSeriesList = [];
            for (let i = 0; i < pressList.length; i++)
            {
                if (pressList[i]!=undefined){
                    items[i] = pressList[i].series;
                    if (AvailableSeriesList.indexOf(items[i]) == -1)
                    {
                        AvailableSeriesList.push(items[i]);
                    }
                }
                
            };
            AvailableSeriesList.sort();
            setSeriesList(AvailableSeriesList.map(x => {return {value: x, label: x } }));
            if (AvailableSeriesList.length == 1)
            {
                setSeries(AvailableSeriesList[0].toString());
                setPressListBySeries(pressList);
                if (series !== 2){
                    fetchSpConditions(AvailableSeriesList[0]);
                }
            }
        };
        getSeriesList();
    },[pressList]);

    const getPressBySeries = (s) => {
        setPressListBySeries(pressList.filter(x => x.series == s))
    };

    const fetchSpConditions = (s) => {
        connectApi
        .get("api/Channels/SpConditionType",
        {
            params:{
                series: s,
                idenduser:endUser[0],
                evergreen:boolevergreen
            }
        },SpConditionListData)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
              );
        });
    };
    const SpConditionListData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idSpecialConditionType,
                label: item.specialConditionType,
            };
        });
        setSpecialConditionTypeList(items);
    };

    const formStart = () => {
        return(
            <Container style={{margin: "16px 0"}}>
                <h5 style={{marginBottom: "12px"}}>{t('scenario')}</h5>
                <Row>
                <Col xs="12" md="12">
                        <RadioButtons
                            id="scenario-radio-button"
                            onChange={(e,value) => {
                                    setScenario(value);
                                    clearForm();
                                }
                            }>
                            <RadioButton value="1" label={t('Net New')} />
                            <RadioButton value="2" label={t('New press for an existing end user')} />
                            <RadioButton value="3" label={t('One or more presses of an existing end user')} />
                        </RadioButtons>
                    </Col>
                </Row>
            </Container>
        );
    };
    const formPressInfo = () => {
        function get_presses(str){
            if (str.length==8){
                connectApi
                .get("api/Channels/endUsers/" + endUser + "/ActivePresses",
                {
                    params:{
                        endUserId: endUser
                    }
                },PressListData)
                .catch((error) => {
                    console.log(error);
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
            }
            
           
        }
        function validateNewPressNumber(str){
            if (str.length == 8 && !isNaN(str))
            {
                if (str.charAt(0) == "2" || str.charAt(0) == "3")
                {
                    setSeries([2]);
                    setSpecialConditionType(0);
                    setSpecialConditionTypeList([]);
                }
                else if (str.charAt(0) == "4")
                {
                    setSeries([3]);
                    setSpecialConditionType(0);
                    fetchSpConditions(3);
                }
                else if (str.charAt(0) == "5" || str.charAt(0)=="6" || str.charAt(0)=="7")
                {
                    connectApi
                    .get("api/Channels/getconfigbyserial",
                    {
                        params:{
                            payload: str.substr(0,4)
                        }
                    },configpress);

                    
                }
                else
                {
                    setSeries("");
                    setSpecialConditionType(0);
                    setSpecialConditionTypeList([]);
                }
                if (scenario == 3){
                    connectApi
                    .get("api/Channels/endUsers/" + endUser + "/ActivePresses",
                    {
                        params:{
                            endUserId: endUser
                        }
                    },PressListData2)
                    .catch((error) => {
                        console.log(error);
                        Swal.fire(
                            "Error " + error?.response?.status,
                            error?.response?.data,
                            "error"
                        );
                    });
                }
                const verifyPrefix = (status,data) => {
                    if(data === ""){
                        setShowMessage(t('runLengthNotContainPrefix'));
                        setShowModalSegment(true);
                        setPressListBySeries([]);
                        setSeries("");
                    } else {
                        if(scenario == 2)
                            get_presses(str);
                        setNewPressSegment(data);
                        setSelectedPress(true);
                    }
                }
                connectApi .get("api/Channels/prefixAndSegment", {
                        params:{
                            payload: str.substr(0,4)
                        }
                    },verifyPrefix
                );
            }
            else
            {
                setSeries("");
                setSpecialConditionType(0);
                setSpecialConditionTypeList([]);
                setSelectedPress(false);
            }
            // These will enable/disable the One Shot and White CPP fields depending on the press serial number.
            // Indigo 1x000: 5000XXXX, 5011XXXX, 5020XXXX
	        // Indigo 20000: 5100XXXX
        	// Indigo 30000: 5200XXXX
            /*if(str.startsWith("5000") || (str.startsWith("5011")) || (str.startsWith("5020"))){
                setOneShotDisabled(false);
                setWhiteDisabled(true);
                setWhiteCpp("");
            } else if (str.startsWith("5100") || str.startsWith("5200")) {
                setOneShotDisabled(true);
                setWhiteDisabled(false);
                setOneShotCpp("");
            } else {
                setOneShotDisabled(true);
                setWhiteDisabled(true);
                setOneShotCpp("");
                setWhiteCpp("");
            }*/
        }

        if (scenario == 0)
        {
            return null;
        }
        else if (scenario == 1)
        {
            return(
                <Container style={{margin: "16px 0"}}>
                    <h5 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h5>
                    <Row>
                        <Col xs="4" md="4">
                            {showChannelList()}
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="new-end-user"
                                value={newEndUser}
                                label={t('endUserName')}
                                onChange={(e) => {setNewEndUser(e)}
                                }
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="new-idend-user"
                                value={endUser}
                                label={t('endUserId')}
                                onChange={(e) => {setEndUser(e)}
                                }
                            />
                        </Col>
                    </Row>  
                    <Row>
                        <Col xs="4" md="4">
                            <br />
                            <TextBox
                                    id="new-press-id"
                                    value={newPress}
                                    label={t('press id')}
                                    maxLength="8"
                                    disabled={newEndUser===""?true:false}
                                    onChange={(e) => {
                                        setNewPress(e);
                                        validateNewPressNumber(e);
                                    }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <TextBox
                                    id="opd-number"
                                    value={opdNumber}
                                    label="OPD #"
                                    maxLength="14"
                                    onKeyPress={(event) => {
                                        if (opdNumber.length < 3){
                                            if (!/^[A-Za-z]+$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        } else {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        setOpdNumber(e);
                                        if (opdNumber.length == 3){
                                            setOpdNumber(opdNumber + "-")
                                        }
                                    }}
                            />
                        </Col>
                    </Row>
                </Container>
            );
        }
        else if (scenario == 2)
        {
            return(
                <Container style={{margin: "16px 0"}}>
                    <h5 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h5>
                    <Row>
                        <Col xs="4" md="4">
                            {showChannelList()}
                        </Col>
                        <Col xs="4" md="4">
                            {showEndUserList()}
                        </Col>
                    </Row>  
                    <Row>
                        <Col xs="4" md="4">
                            <br />
                            <TextBox
                            id="new-press-id"
                            value={newPress}
                            label={t('press id')}
                            maxLength="8"
                            disabled={endUser===""?true:false}
                            onChange={(e) => {
                                setNewPress(e);
                                validateNewPressNumber(e);
                            }
                            }
                        />
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <TextBox
                                    id="opd-number"
                                    value={opdNumber}
                                    label="OPD #"
                                    maxLength="14"
                                    onKeyPress={(event) => {
                                        if (opdNumber.length < 3){
                                            if (!/^[A-Za-z]+$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        } else {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        setOpdNumber(e);
                                        if (opdNumber.length == 3){
                                            setOpdNumber(opdNumber + "-")
                                        }
                                    }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            {showPressList()}
                        </Col>
                    </Row>
                </Container>
            );
        }
        else if (scenario == 3)
        {
            return(
                <Container style={{margin: "16px 0"}}>
                    <h5 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h5>
                    <Row>
                        <Col xs="4" md="4">
                            {showChannelList()}
                        </Col>
                        <Col xs="4" md="4">
                            {showEndUserList()}
                        </Col>
                        <Col xs="4" md="4">
                            {showSeries()}
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <TextBox
                                    id="opd-number"
                                    value={opdNumber}
                                    label="OPD #"
                                    maxLength="14"
                                    onKeyPress={(event) => {
                                        if (opdNumber.length < 3){
                                            if (!/^[A-Za-z]+$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        } else {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        setOpdNumber(e);
                                        if (opdNumber.length == 3){
                                            setOpdNumber(opdNumber + "-")
                                        }
                                    }}
                            />
                        </Col>
                    </Row>  
                    <Row>
                        <Col xs="12" md="12">
                            {showPressList()}
                        </Col>
                    </Row>
                </Container>
            );
        }
    }

    // Displays channel dropdown list. This will always show up.
    const showChannelList = () =>
    {
        return(
            <Select
                id="channel-list"
                label={t('channel')}
                options={channelList}
                value={channel}
                placeholder={channel}
                onChange={(e) => {
                    setChannel([e.value]);
                    setEndUser("");
                    if (scenario != 1){
                        fetchEndUsers(e.value);
                    }
                    setPressList([]);
                    setSeries("");
                    setSpecialConditionType(0);
                    setSelectedPress(false);
                }}
                onClear={() => { clearForm(); }}
            />
        );
    };

    // Displays end user dropdown list. This will always show up.
    const showEndUserList = () =>
    {
        return(
            <Select
                id="end-user-list"
                label={t('endUserName')}
                options={endUserList}
                value={endUser}
                placeholder={endUser}
                onChange={(e) => {
                    setEndUser([e.value]);
                    setPressList([]);
                    setSeries("");
                    setSelectedPress(false);
                    if (scenario == 3){
                        setSpecialConditionType(0);
                        fetchPress(e.value);
                    }
                }}
                onClear={() => {
                    setEndUser("");
                    setPressList([]);
                    setSeries("");
                    setSpecialConditionType(0);
                    setSelectedPress(false);
                }}
            />
        );

    };

    // Displays series dropdown list. This will show only if end user has more than one available series (2, 3 or 4).
    const showSeries = () => {
        if (seriesList.length > 1)
        {
            return(
                <div>
                    <Select
                            id="series-list"
                            label="Series"
                            options={seriesList}
                            value={series}
                            onChange={(e) => {
                                setSeries([e.value]);
                                getPressBySeries(e.value);
                                fetchSpConditions(e.value);
                                setSpecialConditionType(0);
                            }}
                            onClear={() => {
                                setSeries("");
                                setSpecialConditionType(0);
                            }}
                        />
                </div>
            );
        }
        else
        {
            return null;
        }
    };

    // Displays press list for this end user.
    const showPressList = () =>
    {
        function selectRow(dataArray, checked, id){
            const updatedDataArray = [...dataArray];
            const index = updatedDataArray.findIndex((row) => row.uid === id);
            updatedDataArray[index].rowConfig.selected = checked;
            return updatedDataArray;
        };

        // function selectOrDeselectAllItems(tableData, value) {
        //     return tableData.map((row) => {
        //       const newRow = row;
        //       newRow.rowConfig.selected = value;
        //       return newRow;
        //     });
        //   }

        const handleSelect = (event, index) => {
        //console.log("---------handleSelect------------")
        //console.log(event)
        //console.log(pressListBySeries)
        //console.log(event.currentTarget)
            setPressListBySeries(selectRow(pressListBySeries, event.target.checked, index));
            let pressSelected = pressListBySeries.filter(x => x.rowConfig.selected === true);
            if(newPressSegment !== "")
                pressSelected.push([newPressSegment]);
            if (pressListBySeries[0].idPress.charAt(0) == "2" || pressListBySeries[0].idPress.charAt(0) == "3") {
                setSeries([2]);
                if(pressSelected.length == 0)
                    setSpecialConditionType(0);
                setSpecialConditionTypeList([]);
            } else if (pressListBySeries[0].idPress.charAt(0) == "4") {
                setSeries([3]);
                if(pressSelected.length == 0)
                    setSpecialConditionType(0);
                fetchSpConditions(3);
            } else if (pressListBySeries[0].idPress.charAt(0) == "5" || pressListBySeries[0].idPress.charAt(0)=="6" || pressListBySeries[0].idPress.charAt(0)=="7") {
                for (let i = 0; i < pressListBySeries.length; i++){
                    if (pressListBySeries[i].rowConfig.selected == true) {
                        connectApi.get("api/Channels/getconfigbyserial", {
                            params:{
                                payload:pressListBySeries[i].idPress.substr(0,4)
                            }
                        }, configpress);
                        break;
                    }
                }
            } else {
                setSeries("");
                setSpecialConditionType(0);
                setSpecialConditionTypeList([]);
            }
            const filterSelected = pressListBySeries.filter(x => x.rowConfig.selected === true);
            if(filterSelected.length === 0 && scenario == 3)
                setSelectedPress(false);
            else{
                let flag = false;
                filterSelected.forEach(item => { if(item.segment === "") { flag = true; setShowMessage( t('pressid')+":"+item.idPress+" "+t('runLengthNotContainSegment'));setSpecialConditionType(0); } });
                if(flag){
                    setShowModalSegment(true);
                    setSelectedPress(false);
                } else {
                    let mapFamyly = filterSelected.map(x => x.segment);
                    if(newPressSegment !== "")
                        mapFamyly.push(newPressSegment);
                    let filterSegment = mapFamyly.filter((x, idx) => mapFamyly.indexOf(x) === idx );
                    setSegmentSelected(filterSegment);
                    if(filterSegment.length > 1){
                        setShowMessage(t('runLengthDifferentSegment'));
                        setPressListBySeries(selectRow(pressListBySeries, false, index));
                        setShowModalSegment(true);
                    }else
                        setSelectedPress(true);
                }
            }
        };

        function selectAllPageItems(tableData, checked) {
            return tableData.map((row) => {
              const newRow = row;
              const index = tableData.findIndex((p) => p.uid === newRow.uid);
      
              if (index > -1) newRow.rowConfig.selected = checked;
      
              return newRow;
            });
          }
        const handleSelectAll = (event) => {
            setPressListBySeries(selectAllPageItems(pressListBySeries, event.target.checked));
            let pressSelected = pressListBySeries.filter(x => x.rowConfig.selected === true);
            if(newPressSegment !== "")
                pressSelected.push([newPressSegment]);
            if (pressListBySeries[0].idPress.charAt(0) == "2" || pressListBySeries[0].idPress.charAt(0) == "3")
            {
                setSeries([2]);
                if(pressSelected.length == 0)
                    setSpecialConditionType(0);
                setSpecialConditionTypeList([]);
            }
            else if (pressListBySeries[0].idPress.charAt(0) == "4")
            {
                setSeries([3]);
                if(pressSelected.length == 0)
                    setSpecialConditionType(0);
                fetchSpConditions(3);
            }
            else if (pressListBySeries[0].idPress.charAt(0) == "5" || pressListBySeries[0].idPress.charAt(0)=="6" || pressListBySeries[0].idPress.charAt(0)=="7")
            {
                connectApi
                .get("api/Channels/getconfigbyserial",
                {
                    params:{
                        payload: pressListBySeries[0].idPress.substr(0,4)
                    }
                },configpress);

                
            }
            else
            {
                setSeries("");
                setSpecialConditionType(0);
                setSpecialConditionTypeList([]);
            }
            /*if(pressListBySeries[0].classification == "10000" || pressListBySeries[0].classification == "12000"){
                setOneShotDisabled(false);
                setWhiteDisabled(true);
                setWhiteCpp("");
            } else if (pressListBySeries[0].classification == "20000" || pressListBySeries[0].classification == "25K" || pressListBySeries[0].classification == "30000") {
                setOneShotDisabled(true);
                setWhiteDisabled(false);
                setOneShotCpp("");
            } else {
                setOneShotDisabled(true);
                setWhiteDisabled(true);
                setOneShotCpp("");
                setWhiteCpp("");
            }*/
            
            const filterSelected = pressListBySeries.filter(x => x.rowConfig.selected === true);
            if(filterSelected.length === 0 && scenario == 3)
                setSelectedPress(false);
            else{
                let flag = false;
                filterSelected.forEach(item => { if(item.segment === "") { flag = true; setShowMessage( t('pressid')+":"+item.idPress+" "+t('runLengthNotContainSegment'));setSpecialConditionType(0); } });
                if(flag){
                    setShowModalSegment(true);
                    setSelectedPress(false);
                } else {
                    let mapFamyly = filterSelected.map(x => x.segment);
                    if(newPressSegment !== "")
                        mapFamyly.push(newPressSegment);
                    let filterSegment = mapFamyly.filter((x, idx) => mapFamyly.indexOf(x) === idx );
                    setSegmentSelected(filterSegment);
                    if(filterSegment.length > 1){
                        setShowMessage(t('runLengthDifferentSegment'));
                        setPressListBySeries(selectAllPageItems(pressListBySeries, false));
                        setShowModalSegment(true);
                        setSelectedPress(false);
                        setSpecialConditionType(0);
                    }else
                        setSelectedPress(true);
                }
            }
        }
        function selectionState(dataArray) {
            const total = dataArray.length;
            const selected = dataArray.filter((row) => row.rowConfig.selected).length;

            switch (selected) {
              case 0:
                return 'none';
              case total:
                return 'all';
              default:
                return 'indeterminated';
            }
        }
        if (series == 0)
        {
            return null;
        } else {
            if (pressListBySeries.length>0){
                    return(
                    <div>
                        <br />
                        <Table
                            name="press-table"
                            rowSelector="multiSelection"
                            onSelect={handleSelect}
                            rowSelectAllState={selectionState(pressListBySeries)}
                            onSelectAllPageItems={handleSelectAll}
                            columns={[
                                {
                                    id: "uid",
                                    index:"hidden"
                                },
                                {
                                    id: "idPress",
                                    label: t('press id'),
                                },
                                {
                                    id: "classification",
                                    label: t('classification'),
                                },
                                {
                                    id: "series",
                                    label: "Series",
                                },
                                {
                                    id: "segment",
                                    label: t('segment'),
                                }
                            ]}
                            data={pressListBySeries} />
                    </div>
                ); 
            }else{
                return null;
            }
            
        };
    };
    function filter(array, filters) {
        let arrayFiltered = array;
    
        Object.keys(filters).forEach((value) => {
          const filterValue = filters[value];
          const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
          if (filter) {
            arrayFiltered = arrayFiltered.filter((a) => {
              const aUpper = a[value] && a[value].toString().toUpperCase();
              const filterUpper = filter && filter.toString().toUpperCase();
      
              return aUpper.indexOf(filterUpper) > -1;
            });
          }
        });
    
        return arrayFiltered;
    }
    // Displays special condition options to choose from. This will show only for series 3 or 4.
    const showSpConditionTypeList = () =>{
        if(showModalSegment){
            return(
                <Modal
                    id="regular-modal" 
                    closeButton
                    onClose={() => setShowModalSegment(false)}
                    show={showModalSegment}
                    title={t('notifyWrongValues')}
                >
                    <p>{showMessage}</p>
                </Modal>
            );
        } else if (series == 0 )
        {
            return null;
        } else {
            if (series == 2){
                return(
                    <Col xs="8" md="8">
                        <br />
                        <InlineNotification
                            title={t('noSeries2')}
                            type="warning"
                        />
                    </Col>
                );
            } else if(selectedPress) {
                return(
                    <>
                        <Col xs="4" md="4">
                            <br />  
                            <Select
                                id="special-condition-type-list"
                                label={t('Special Condition Type')}
                                options={specialConditionTypeList}
                                value={specialConditionType.toString()}
                                onChange={(e) => {
                                    setSpecialConditionType(e.value);
                                    //Add methos from compare famyly
                                }}
                                onClear={() => {
                                    setSpecialConditionType([]);
                                }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <h4>
                            {
                                (specialConditionType == 0) ? null :
                                (specialConditionType == 8 || specialConditionType == 12 || specialConditionType == 17) ? "Bonus Special Table" :
                                (specialConditionType == 14) ? "Fixed Bonus" :
                                filter(specialConditionTypeList,{value: specialConditionType})[0].label
                            }</h4>
                        </Col>
                    </>
                );
            } else { return null; };
        };
    };

    // These hooks may be used either for Max Cost Per Print or Bonus Table
    const [isLastTier, setIsLastTier] = useState(false)
    const [minPrint, setMinPrint] = useState(1)
    const [maxPrint, setMaxPrint] = useState("")

    // Depending on the chosen special condition, one of the following forms will display for the user.
    //
    // Max Cost per Impression
    const [blackCpp, setBlackCpp] = useState("")
    const [otherCpp, setOtherCpp] = useState("")
    const [oneShotCpp, setOneShotCpp] = useState("")
    const [whiteCpp, setWhiteCpp] = useState("")
    const [compensationTable, setCompensationTable] = useState([])
    const [lowCoverage, setLowCoverage] = useState(false)
    const showMaxCostPerImpression = () => {
        const handleClick = () => {
            let obj = [...compensationTable];
            if (maxPrint == ""){
                alert(t('alertMaxCost1'))
            } else if (maxPrint < minPrint) {
                alert(t('alertMaxCost2') + (minPrint) + ".")
            } else if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) ){
                alert(t('alertMaxCost3'))
            } else {
                obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                // obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"blackCpp":blackCpp == "" ? 0 : blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                setMinPrint(maxPrint+1);
                setMaxPrint("");
                setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                setCompensationTable(obj);
            }
        };

        const handleLast = () => {
            let obj = [...compensationTable];
            if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) )
                alert(t('alertMaxCost3'))
            else {
                if(!(specialConditionType == 13))
                    obj.push({"minPrint":minPrint,"maxPrint":999999999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                else
                    obj.push({"minPrint":minPrint,"maxPrint":999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                setMinPrint(1);
                setMaxPrint("");
                setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                setCompensationTable(obj);
                setIsLastTier(true);
            }
        };

        if (specialConditionType == 1 || specialConditionType == 13 || specialConditionType == 22  || specialConditionType == 23 || specialConditionType==26 || specialConditionType==30){
            return(
                <>
                {(pressList.find(e=>e.globalaccount===true) && [26,22].includes(specialConditionType))?(<></>):(<>
                    <br />
                    <Row>
                        <br />
                        <Col md="12">
                            <h4 style={{marginLeft:"35%"}}> {t('bonus')} Maximum CPP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            {specialConditionType == 13?(<>
                            <TextBox
                                id="min-print"
                                label="Min LS Mark"
                                maxLength="3"
                                value={minPrint}
                                disabled
                            /><br />
                            <TextBox
                                id="max-print"
                                label="Max LS Mark"
                                maxLength="3"
                                value={maxPrint}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                disabled={isLastTier}
                            /><br />
                            </>):(<>
                            <TextBox
                                id="min-print"
                                label={t('bonustable.table1')}
                                maxLength="9"
                                value={minPrint}
                                disabled
                            /><br />
                            <TextBox
                                id="max-print"
                                label={t('bonustable.table2')}
                                maxLength="9"
                                value={maxPrint}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                disabled={isLastTier}
                            /><br />
                            </>)}
                            <TextBox
                                id="black-cpp"
                                label={t('prices.blackcommprice')}
                                maxLength="10"
                                value={blackCpp}
                                onChange={(e) => { if(!isNaN(e)) setBlackCpp(e); }}
                                disabled={isLastTier}
                            /><br />
                            <TextBox
                                id="other-cpp"
                                label={t('prices.othercommprice')}
                                maxLength="10"
                                value={otherCpp}
                                onChange={(e) => { if(!isNaN(e)) setOtherCpp(e); }}
                                disabled={isLastTier}
                            /><br />
                            <TextBox
                                id="one-shot-cpp"
                                label={t('prices.oneshotcommprice')}
                                maxLength="10"
                                value={oneShotCpp}
                                onChange={(e) => { if(!isNaN(e)) setOneShotCpp(e); }}
                                disabled={isLastTier?true:oneShotDisabled?true:false}
                            /><br />
                            <TextBox
                                id="white-cpp"
                                label={t('prices.whitecommprice')}
                                maxLength="10"
                                value={whiteCpp}
                                onChange={(e) => { if(!isNaN(e)) setWhiteCpp(e); }}
                                disabled={isLastTier?true:whiteDisabled?true:false}
                            /><br />
                            <Button
                                id="add-to-compensation-array"
                                onClick={handleClick}
                                leadingIcon={<IconPlus />}
                                disabled={isLastTier}
                            >
                                {t('addTier')}
                            </Button>
                            <Button
                                id="last-compensation-array"
                                style={{ marginLeft:"15px" }}
                                onClick={handleLast}
                                leadingIcon={<IconListView />}
                                disabled={isLastTier}
                            >
                                {t('lastTier')}
                            </Button><br />
                            <Button
                                id="clear-compensation-array"
                                appearance="secondary"
                                style={{ marginTop:"15px" }}
                                leadingIcon={<IconTrash />}
                                onClick={() => {
                                    setCompensationTable([]);
                                    setMinPrint(1);
                                    setMaxPrint("");
                                    setBlackCpp("");
                                    setOtherCpp("");
                                    setOneShotCpp("");
                                    setWhiteCpp("");
                                    setIsLastTier(false);
                                }}
                            >
                                {t('clearTable')}
                            </Button><br /><br />
                        </Col>
                        <Col xs="8" md="8">
                        <Table
                            name="bonus-table"
                            columns={[
                                {
                                    id: "minPrint",
                                    label: specialConditionType == 13?("Min LS Mark %"):(t('bonustable.table1'))
                                },
                                {
                                    id: "maxPrint",
                                    label: specialConditionType == 13?("Max LS Mark %"):(t('bonustable.table2'))
                                },
                                {
                                    id: "blackCpp",
                                    label: t('prices.blackcommprice')
                                },
                                {
                                    id: "otherCpp",
                                    label: t('prices.othercommprice')
                                },
                                {
                                    id: "oneShotCpp",
                                    label: t('prices.oneshotcommprice')
                                },
                                {
                                    id: "whiteCpp",
                                    label: t('prices.whitecommprice')
                                }
                            ]}
                            data={compensationTable} />
                            <br />
                            <p>{t('memoMaxCost1')}
                                <ul style={{marginLeft:"40px"}}>
                                    <li><u>Indigo 1x000</u>: B2 (A3 <b>x 2</b>)</li>
                                    <li><u>Indigo 20000</u>: B1 (A3 <b>x 4</b>)</li>
                                    <li><u>Indigo 30000</u>: B2 (A3 <b>x 2</b>)</li>
                                </ul>
                            </p><br />
                            <p>{t('memoMaxCost2')}
                            <ul style={{marginLeft:"40px"}}>
                                <li><u>Indigo 1x000</u>: {t('memoMaxCost3')}</li>
                                <li><u>Indigo 20000 &amp; 30000</u>: {t('memoMaxCost4')}</li>
                            </ul>
                            </p>
                        </Col>
                    </Row>
                
                
                </>)}
                
                {specialConditionType == 23?(<>
                <Checkbox
                    id = "id-low-coverage-box"
                    label = {t('credit') + " / " + t('debit') + " LSMark?"}
                    checked = {lowCoverage}
                    onChange = {(e) => {
                        setLowCoverage(e.target.checked);
                        setBonusLSDiscount([]);
                        setBonusLSDiscountSend([]);
                        setMinPrintLS(1);
                        setMaxPrintLS("");
                        setBonusLS("");
                        setIsLastTierLS(false);
                        setIsAddOneMin(false);
                    }}
                />
                <br />
                </>):((specialConditionType==26?(<>
                    <Row>
                        <Col xs="4">
                            <TextBox
                                id="minimum-impressions"
                                label={"LSMark Minimum"}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />  
                            {(pressList.find(e=>e.globalaccount===true))?(
                                <>{t("notelifespandgateg")}</>
                            ):(<>{t("notelifespandgate")}</>)}
                        </Col>
                        <Col xs="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                    </Row>
                    
                </>):("")))}
                </>
            );
        } else {
            return null;
        };
    };

    // Bonus LSDisconunt Table
    const [bonusLSDiscount, setBonusLSDiscount] = useState([])
    const [bonusLSDiscountSend, setBonusLSDiscountSend] = useState([])
    const [bonusLS, setBonusLS] = useState("")
    const [minPrintLS, setMinPrintLS] = useState(1)
    const [maxPrintLS, setMaxPrintLS] = useState("")
    const [isAddOneMin, setIsAddOneMin] = useState(false)
    const [isLastTierLS, setIsLastTierLS] = useState(false)
    const showBonusLSDiscount = () => {
        const handleClick = () => {
            let obj = [...bonusLSDiscount];
            let objSend = [...bonusLSDiscountSend];
            if (maxPrintLS < 0 || isNaN(maxPrintLS) 
                || minPrintLS < 0 || isNaN(minPrintLS)){
                alert(t('alertMaxCost1'))
            } else if (maxPrintLS < minPrintLS) {
                alert(t('alertMaxCost2'))
            } else if (isNaN(bonusLS)) {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrintLS,"maxPrint":maxPrintLS, "bonus":`${(bonusLS)} %`});
                setMinPrintLS(parseInt(maxPrintLS)+1);
                setMaxPrintLS("");
                setBonusLS("");
                setBonusLSDiscount(obj);
                objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":maxPrintLS, "Discount":bonusLS});
                setBonusLSDiscountSend(objSend);
                setIsAddOneMin(true);
            }
        };

        const handleLast = () => {
            let obj = [...bonusLSDiscount];
            let objSend = [...bonusLSDiscountSend];
            if (isNaN(bonusLS) || bonusLS == "") {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrintLS,"maxPrint":9999, "bonus":`${(bonusLS)} %`});
                setMinPrintLS("");
                setMaxPrintLS("");
                setBonusLS("");
                setBonusLSDiscount(obj);
                objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":9999, "Discount":bonusLS});
                setBonusLSDiscountSend(objSend);
                setIsLastTierLS(true);
            }
        };

        if (specialConditionType == 22  || (specialConditionType == 23 && lowCoverage)){
            return(
                <Row>
                    <br />
                    <Col md="12">
                        <h4 style={{marginLeft:"35%"}}> {t('bonus')} LSMark </h4>
                    </Col>
                    <br />
                    <Col xs="4" md="4">
                        <TextBox
                            id="min-print"
                            label={t("InitialLSMark")}
                            maxLength="4"
                            value={minPrintLS}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e == "") setMinPrintLS(""); else setMinPrintLS(parseInt(e)); }}
                            disabled={isLastTierLS?true:isAddOneMin}
                        /><br />
                        <TextBox
                            id="max-print"
                            label={t("EndLSMark")}
                            maxLength="4"
                            value={maxPrintLS}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e=="") setMaxPrintLS(""); else setMaxPrintLS(parseInt(e)); }}
                            disabled={isLastTierLS}
                        /><br />
                        <TextBox
                            id="bonus"
                            label={t('bonus') + " %"}
                            maxLength="5"
                            value={bonusLS}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setBonusLS(e); }}
                            disabled={isLastTierLS}
                        /><br />
                        <Button
                            id="add-to-bonus-array"
                            onClick={handleClick}
                            leadingIcon={<IconPlus />}
                            disabled={isLastTierLS}
                        >
                            {t('addTier')}
                        </Button>
                        <Button
                            id="last-bonus-array"
                            style={{ marginLeft:"15px" }}
                            onClick={handleLast}
                            leadingIcon={<IconListView />}
                            disabled={isLastTierLS}
                        >
                            {t('lastTier')}
                        </Button><br />
                        <Button
                            id="clear-bonus-array"
                            appearance="secondary"
                            style={{ marginTop:"15px" }}
                            leadingIcon={<IconTrash />}
                            onClick={() => {
                                setBonusLSDiscount([]);
                                setBonusLSDiscountSend([]);
                                setMinPrintLS(1);
                                setMaxPrintLS("");
                                setBonusLS("");
                                setIsLastTierLS(false);
                                setIsAddOneMin(false);
                            }}
                        >
                            {t('clearTable')}
                        </Button><br /><br />
                    </Col>
                    <Col xs="8" md="8">
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "minPrint",
                                label: t("InitialLSMark")
                            },
                            {
                                id: "maxPrint",
                                label: t("EndLSMark")
                            },
                            {
                                id: "bonus",
                                label: t('bonus'),
                            }
                        ]}
                        data={bonusLSDiscount} />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    // Bonus Special Table    
    const [bonusTable, setBonusTable] = useState([])
    const [bonus, setBonus] = useState("")
    const showBonusSpecialTable = () => {
        const handleClick = () => {
            let obj = [...bonusTable];
            if (maxPrint < 0 || isNaN(maxPrint)){
                alert(t('alertMaxCost1'))
            } else if (maxPrint < minPrint) {
                alert(t('alertMaxCost2'))
            } else if (bonus < 0 || isNaN(bonus)) {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"bonus":bonus});
                setMinPrint(maxPrint+1);
                setMaxPrint("");
                setBonus("");
                setBonusTable(obj);
            }
        };

        const handleLast = () => {
            let obj = [...bonusTable];
            if (!Math.sign(bonus) || bonus == "") {
                alert(t('alertBonus'))
            }
            else {
                obj.push({"minPrint":minPrint,"maxPrint":999999999,"bonus":bonus});
                setMinPrint("");
                setMaxPrint("");
                setBonus("");
                setBonusTable(obj);
                setIsLastTier(true);
            }
        };

        if (specialConditionType == 2 || specialConditionType == 8 || specialConditionType == 12 || specialConditionType == 15 || specialConditionType == 17){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox
                            id="min-print"
                            label={t('bonustable.table1')}
                            maxLength="9"
                            value={minPrint}
                            disabled
                        /><br />
                        <TextBox
                            id="max-print"
                            label={t('bonustable.table2')}
                            maxLength="9"
                            value={maxPrint}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                            disabled={isLastTier}
                            
                        /><br />
                        <TextBox
                            id="bonus"
                            label="Bonus %"
                            maxLength="3"
                            value={bonus}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setBonus(e); }}
                            disabled={isLastTier}
                        /><br />
                        <Button
                            id="add-to-bonus-array"
                            onClick={handleClick}
                            leadingIcon={<IconPlus />}
                            disabled={isLastTier}
                        >
                            {t('addTier')}
                        </Button>
                        <Button
                            id="last-bonus-array"
                            style={{ marginLeft:"15px" }}
                            onClick={handleLast}
                            leadingIcon={<IconListView />}
                            disabled={isLastTier}
                        >
                            {t('lastTier')}
                        </Button><br />
                        <Button
                            id="clear-bonus-array"
                            appearance="secondary"
                            style={{ marginTop:"15px" }}
                            leadingIcon={<IconTrash />}
                            onClick={() => {
                                setBonusTable([]);
                                setMinPrint(1);
                                setMaxPrint("");
                                setBonus("");
                                setIsLastTier(false);
                            }}
                        >
                            {t('clearTable')}
                        </Button><br /><br />
                    </Col>
                    <Col xs="8" md="8">
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "minPrint",
                                label: t('bonustable.table1')
                            },
                            {
                                id: "maxPrint",
                                label: t('bonustable.table2')
                            },
                            {
                                id: "bonus",
                                label: "Bonus",
                            }
                        ]}
                        data={bonusTable} />
                    </Col>
                    <Col xs="4" md="4">
                        <br />
                        <Checkbox
                            id="epm-bonus-table"
                            label="EPM"
                            onChange={(e) => {
                                if (specialConditionType == 2) {
                                    setSpecialConditionType(12);
                                } else if (specialConditionType == 8) { 
                                    setSpecialConditionType(17);
                                } else {
                                    setSpecialConditionType(0);
                                }
                            }}
                        />
                        <br />
                        <Checkbox
                            id="combine-clicks-fixed-bonus"
                            label="Combine Clicks with other client"
                            onChange={(e) => {
                                if (specialConditionType == 2) {
                                    setSpecialConditionType(8);
                                } else if (specialConditionType == 12) { 
                                    setSpecialConditionType(17);
                                } else {
                                    setSpecialConditionType(0);
                                }
                            }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    // Fixed Bonus
    const [percentage, setPercentage] = useState("") // Can be used for either Fixed Bonus or Tiers Up
    const [minimumImp, setMinimumImp] = useState(0)
    const showFixedBonus = () => {
        if (specialConditionType == 3 || specialConditionType == 14 || specialConditionType == 23 || specialConditionType==25){
            return(
                <Row>
                    {( specialConditionType==3 || specialConditionType==14 ) ? (<>
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus"
                                label="Fixed Bonus %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e); }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions"
                                label={t('bonustable.table1')}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <Checkbox
                                id="epm-fixed-bonus"
                                name="epm-fixed-bonus"
                                label="EPM"
                                onChange={(e) => {
                                    if (specialConditionType == 3) {
                                        setSpecialConditionType(14);
                                    }
                                    else {
                                        setSpecialConditionType(3);
                                    }
                                }}
                            />
                        </Col>
                    </>):(
                    (specialConditionType==23)?(//type 23: Low Coverage Program
                    <>
                        <br />
                        <Col md="12">
                            <h4> {t('bonus')} LCP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions2"
                                label="Coverage Below %"
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                    </>):(
                        //type 25: Frame width
                    <>
                    <br />
                        <Col md="12">
                            <h4> {t('bonus')} FWP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions2"
                                label="Coverage Below (mm)"
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                    </>)
                        
                    )}
                    <br /> <br />
                </Row>
            );
        } else if(specialConditionType==27) {
            //console.log(endUser[0]);
            //console.log(channel[0]);
            //console.log(pressList[0].idPress);
            connectApi
            .getWithParams("api/Channels/getClickTiers",
            {
                
                idcustomer: channel[0],
                idenduser:endUser[0],
                idpress: pressList[0].idPress
                
            },(status, data) => {
                //console.log(data);
            })
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                  );
            });
            
        }else {
            return null;
        };
    };

    const showTiersUp = () => {
        if (specialConditionType == 4 || specialConditionType == 19){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <Select
                            id="tiers-up"
                            label="Tiers Up %"
                            value={[percentage]}
                            options={[ 
                                { value: 5, label: '1 Tier Up - 5%' },
                                { value: 10, label: '2 Tiers Up - 10%' },
                                { value: 15, label: '3 Tiers Up - 15%' }
                              ]}
                            onChange={(e) => {
                                setPercentage(e.value);
                            }}
                            onClear={() =>{
                                setPercentage();
                            }}
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-impressions"
                            label={t('bonustable.table1')}
                            maxLength="9"
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };
    // Run Length
    const [MinimumPrint, setMinimumPrint]=useState(0);
    const showRunLength = () => {
        if ( specialConditionType === 21 ){
            let segmentCompare = "";
            if(scenario == 1)
                segmentCompare = newPressSegment;
            else
                segmentCompare = segmentSelected;
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox 
                            label="Minimum Print" 
                            value={MinimumPrint}
                            maxLength="9"
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setMinimumPrint(e); }} 
                        />
                    </Col>
                    {segmentCompare == "L&P"?(
                    <Col xs="4" md="4">
                        <Select
                            id="minimun_metters"
                            label={t('minimumMetters')+" L&P*"}
                            value={minimumImp===0?'':[minimumImp]}
                            options={[ 
                                { value: 2000, label: t('minimumMetters')+' - 2,000' },
                                { value: 3000, label: t('minimumMetters')+' - 3,000' },
                                { value: 3500, label: t('minimumMetters')+' - 3,500' },
                                { value: 5000, label: t('minimumMetters')+' - 5,000' },
                                { value: 7500, label: t('minimumMetters')+' - 7,500' },
                                { value: 10000, label: t('minimumMetters')+' - 10,000' },
                                { value: 12500, label: t('minimumMetters')+' - 12,500' },
                                { value: 15000, label: t('minimumMetters')+' - 15,000' }
                            ]}
                            onChange={(e) => {
                                setMinimumImp(e.value);
                            }}
                            clearIcon={false}
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <Select
                            id="minimun_sheets"
                            label={t('minimumSheets')+" GCP*"}
                            value={minimumImp===0?'':[minimumImp]}
                            options={[ 
                                { value: 2000, label: t('minimumSheets')+' - 2,000' },
                                { value: 2500, label: t('minimumSheets')+' - 2,500' },
                                { value: 3000, label: t('minimumSheets')+' - 3,000' },
                                { value: 4000, label: t('minimumSheets')+' - 4,000' },
                                { value: 5000, label: t('minimumSheets')+' - 5,000' },
                                { value: 6000, label: t('minimumSheets')+' - 6,000' },
                                { value: 7000, label: t('minimumSheets')+' - 7,000' }
                            ]}
                            onChange={(e) => {
                                setMinimumImp(e.value);
                            }}
                            clearIcon={false}
                        />
                    </Col>   
                    )}
                    {series==3?(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('bonusPercentageRL')+" *"}
                            maxLength="3"
                            value={percentage || ''}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e); }}
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('committedPPIRL')+" *"}
                            maxLength="9"
                            value={percentage || ''}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setPercentage(e); }}
                        />
                        *{"(" + t('valueCaptureNativeFormat') + ")"}
                    </Col>    
                    )}
                </Row>
            );
            
        } else {
            return null;
        };
    };

    // Combine clicks
    const [channelCombineClicks, setChannelCombineClicks] = useState("")
    const [endUserListCombineClicks, setEndUserListCombineClicks] = useState([])
    const [endUserCombineClicks, setEndUserCombineClicks] = useState("")
    const [endUserNameCombine, setEndUserNameCombine] = useState("")
    const [combineClicksList, setCombineClicksList] = useState([])
    // Fetch data
    const fetchEndUsersCombineClicks = (channel) => {
            connectApi
            .get("api/Channels/endUsers",
            {
                params:{
                    customerId: channel,
                    status: "Active",
                }
            },EndUserListCombineClicksData)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                  );
            });
        };
        const EndUserListCombineClicksData = (status, data) => {
            const items = data.map((item) => {
                return{
                    value: item.idEndUser,
                    label: item.endUserName,
                };
            });
            setEndUserListCombineClicks(items);
        };

    // Form
    const showCombineClicks = () => {
        const handleClick = () => {
            let obj = [...combineClicksList];
            obj.push({"channelCombineClicks":channelCombineClicks[0],"endUserCombineClicks":endUserCombineClicks[0],"endUserName":endUserNameCombine});
            setCombineClicksList(obj);
            setChannelCombineClicks("");
            setEndUserCombineClicks("");
            setEndUserListCombineClicks([]);
        };

        const handleClear = () => {
            setCombineClicksList([]);
        }

        if (specialConditionType == 7 || specialConditionType == 8 || specialConditionType == 17){
            return(
                <div>
                <Row>
                    <Col xs="4" md="4">
                        <Select
                        id="channel-list-combine"
                        label={t('channel')}
                        options={channelList}
                        value={channelCombineClicks}
                        placeholder={channelCombineClicks}
                        onChange={(e) => {
                            setChannelCombineClicks([e.value]);
                            setEndUserCombineClicks("");
                            setEndUserListCombineClicks([]);
                            fetchEndUsersCombineClicks(e.value);
                        }}
                        onClear={() => {
                            setChannelCombineClicks("");
                            setEndUserCombineClicks("");
                            setEndUserListCombineClicks([]);
                        }}
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <Select
                            id="end-user-list-combine"
                            label={t('endUser')}
                            options={endUserListCombineClicks}
                            value={endUserCombineClicks}
                            placeholder={endUserCombineClicks}
                            onChange={(e) => {
                                setEndUserNameCombine(e.label);
                                setEndUserCombineClicks([e.value]);
                            }}
                            onClear={() => {
                                setEndUserCombineClicks("");
                            }}
                            />
                    </Col>
                    <Col xs="4" md="4">
                        <Button
                            id="add-combine-clicks"
                            leadingIcon={<IconPlus />}
                            onClick={handleClick}
                        >
                            {t('addCombineClicks')}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="12">
                        <br />
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "endUserCombineClicks",
                                label: t('endUserId')
                            },
                            {
                                id: "endUserName",
                                label: t('endUser')
                            }
                        ]}
                        data={combineClicksList} />
                    </Col>
                    <Col xs="4" md="4">
                        <br />
                        <Button
                            id="clear-combine-clicks"
                            appearance="secondary"
                            leadingIcon={<IconTrash />}
                            onClick={handleClear}
                        >
                            {t('clearCombineClicks')}
                        </Button>
                    </Col>
                </Row>
                </div>
            );
        } else {
            return null;
        };
    };

    const [minumimDiscount, setMinumumDiscount] = useState("")
    const showMinumimDiscount = () => {
        if (specialConditionType == 11){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-discount"
                            label="Minumum Discount %"
                            value={minumimDiscount}
                            maxLength="3"
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setMinumumDiscount(e); }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    const [businessJustification, setBusinessJustification] = useState("")
    const [volumeGrowth, setvolumeGrowth] = useState(0)
    const [competition, setCompetition] = useState("")
    const [businessOpportunities, setBusinessOpportunities] = useState("")
    const [comments, setComments] = useState("")
    const [endUserContactName, setEndUserContactName] = useState("")
    const [endUserContactPhone, setEndUserContactPhone] = useState("")
    const [endUserContactPosition, setEndUserContactPosition] = useState("")
    const [effectiveMonths, setEffectiveMonths] = useState(3)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [submitBtn, setSubmitBtn] = useState(false)
    const formBusinessInfo = () => {
        const increaseEndDate = (e) => {
            let date = new Date(Date.parse(startDate));
            date.setMonth(date.getMonth() + (parseInt(e)-1));
            setEndDate(t('month' + (date.getMonth()+1).toString()) + ' ' + date.getFullYear());
            if(specialConditionType==30){
                setEndDate(t('month' + (12).toString()) + ' ' +2099);
            }
        }

        if (specialConditionType == 0){
            return null;
        } else {
            return (
                <Container style={{margin: "16px 0"}}>
                    <h5 style={{marginBottom: "12px"}}>{t('Business Information')}</h5>
                    <Row>
                        <Col xs="12" md="12">
                            <TextArea
                                id="business-justification"
                                label={t('Business Justification')}
                                maxLength="2000"
                                onChange={(e) => {setBusinessJustification(e)}}
                                resize
                                required
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="volume-growth"
                                label={t('Volume Growth')}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                maxLength="9"
                                onChange={(e) => {
                                    setvolumeGrowth(e)
                                }}
                                required
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <TextArea
                                id="competition"
                                label={t('Competition')}
                                maxLength="2000"
                                onChange={(e) => {setCompetition(e)}}
                                resize
                                required
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                    <Col xs="12" md="12">
                            <TextArea
                                id="business-opportunities"
                                label={t('Business Opportunities')}
                                onChange={(e) => {setBusinessOpportunities(e)}}
                                resize
                                required
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <TextArea
                                id="comments"
                                label={t('comments')}
                                onChange={(e) => {setComments(e)}}
                                resize
                                required
                            /><br />
                        </Col>
                    </Row>
                    <h5 style={{marginBottom: "12px"}}>{t('endUserContact')}</h5>
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="contact-name"
                                label={t('contactName')}
                                maxLength = "100"
                                onChange={(e) => {setEndUserContactName(e)}}
                                required
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="contact-phone"
                                label={t('phone')}
                                maxLength="20"
                                onChange={(e) => {setEndUserContactPhone(e)}}
                                required
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="contact-position"
                                label={t('jobPosition')}
                                maxLength="100"
                                onChange={(e) => {setEndUserContactPosition(e)}}
                                required
                            /><br />
                        </Col>
                    </Row>
                    <h5 style={{marginBottom: "12px"}}>{t('Effective Time')}</h5>
                    <Row>
                        <Col xs="4" md="4">
                            <Select
                                name="start-date"
                                label={t('startMonth')}
                                value={startDate}
                                options={validFromList}
                                onChange={(e) => {
                                    if(specialConditionType==30){
                                        setEffectiveMonths(1);
                                        increaseEndDate(1);
                                    }
                                    setStartDate([e.value])}}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="effective-months"
                                label={t('effMonth')}
                                maxLength="2"
                                disabled={()=>{
                                        if(specialConditionType==30){
                                            return false
                                        }else{
                                            return !startDate
                                        }
                                    }
                                    }
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                onChange={(e) => {
                                    if (e != 0) {
                                        setEffectiveMonths(e);
                                        increaseEndDate(e);
                                    } else {
                                        setEffectiveMonths(1);
                                        increaseEndDate(1);
                                    }
                                }
                                }
                                required
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="end-date"
                                label={t('endMonth')}
                                value={endDate}
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <br />
                            <Button
                                id="submit-button"
                                disabled={submitBtn}
                                onClick={validateForm}>
                                    {t('Submit')}
                            </Button>
                            <Button
                                id="clear-button"
                                style={{ marginLeft:"15px" }}
                                appearance="secondary"
                                onClick={() => clearForm()}>
                                    {t('Clear')}
                            </Button>
                        </Col>
                    </Row>
                    <ConfirmationModal
                        id="confirmation-modal" 
                        onConfirm={() => {setShowModalSegmentNotSelected(false);handleSubmit();} }
                        onClose={() => setShowModalSegmentNotSelected(false)}
                        closeButtonLabel={t('back')}
                        show={showModalSegmentNotSelected}
                        title={t('requestConfirmation')}
                    >
                        <p> {t('requestConfirmationSpecialCondition')} </p>
                    </ConfirmationModal>
                </Container>
            );
        };
    };

    const validateForm = () => {
        let missing = [];
        if (businessJustification === "") { missing.push(t('Business Justification')) }
        if (volumeGrowth === 0 || volumeGrowth == "") { missing.push(t('Volume Growth')) }
        if (competition === "") { missing.push(t('Competition')) }
        if (businessOpportunities === "") { missing.push(t('Business Opportunities')) }
        if (comments === "") { missing.push(t('comments')) }
        if (endUserContactName === "") { missing.push(t('contactName')) }
        if (endUserContactPhone === "") { missing.push(t('phone')) }
        if (endUserContactPosition === "") { missing.push(t('jobPosition')) }
        if (startDate === "" || effectiveMonths === null) { missing.push(t('startMonth')) }
        if (effectiveMonths === 0 || effectiveMonths === "") { missing.push(t('effMonth')) }
        if ((specialConditionType === 1 || specialConditionType === 22 || specialConditionType === 23 || specialConditionType === 30) && compensationTable.length === 0) { 
            if(pressList.find(e=>e.globalaccount===true)){

            }else{
                missing.push(t('committed_price_table')) 
            }
            
        }
        if (specialConditionType === 2 && bonusTable.length === 0) { missing.push(t('special_bonus_table')) }
        if (specialConditionType === 7 && combineClicksList.length === 0) { missing.push(t('addCombineClicks')) }
        if ((specialConditionType === 17 || specialConditionType === 8 ) && combineClicksList.length === 0) { missing.push(t('addCombineClicks')) }
        if ((specialConditionType === 22 || (specialConditionType == 23 && lowCoverage)) && bonusLSDiscountSend.length === 0 ) { missing.push(t('missingbonusTable')) }
        if ((specialConditionType === 21 || specialConditionType === 23) && percentage === 0 ) { missing.push(t('addPercentage')) }
        if ((specialConditionType === 21 || specialConditionType === 23) && minimumImp === 0 ) { missing.push(t('addMinimun')) }
        if (specialConditionType === 11 && minumimDiscount === 0 ) { missing.push(t('addPercentage')) }

        if ( (specialConditionType === 1 || specialConditionType === 30) && compensationTable.length != 0 )
            if ( compensationTable[compensationTable.length-1].maxPrint != 999999999 ) { missing.push(t('missingLastTierTable') + "\"" + t('lastTier') + "\"") }
        if ( specialConditionType === 2 && bonusTable.length != 0 )
            if ( bonusTable[bonusTable.length-1].maxPrint != 999999999 ) { missing.push(t('missingLastTierTable') + "\"" + t('lastTier') + "\"") }
        if ( specialConditionType === 22 || (specialConditionType == 23 && lowCoverage)) {
            if ( compensationTable.length != 0 )
                if ( compensationTable[compensationTable.length-1].maxPrint != 999999999 ) { missing.push(t('missingLastTierTable') + "\"" + t('lastTier') + "\"") }
            if ( bonusLSDiscountSend.length != 0 ) 
                if ( bonusLSDiscountSend[bonusLSDiscountSend.length-1].FinalLSMark != 9999 ) { missing.push(t('missingLastTierTable') + "\"" + t('lastTier') + "\"");  }
        }

        if (missing.length > 0) {
            let missingFields = "";
            for(let i = 0; i < missing.length; i++) 
                missingFields += "-" + missing[i] + "\n";
            
            alert(t('missingMandatoryFields') + "\n" + missingFields);
        } else {
            let filterSelectedTrue = pressListBySeries.filter(x => x.rowConfig.selected === true);
            let filterSelectedFalse = pressListBySeries.filter(x => x.rowConfig.selected === false && x.segment == segmentSelected);
            if (scenario == 1 || scenario == 2)
                filterSelectedTrue.push([segmentSelected]);
            if (filterSelectedFalse.length >= filterSelectedTrue.length)
                setShowModalSegmentNotSelected(true);
            else
                handleSubmit();
        }
    }

    const handleSubmit = () => {
        setSubmitBtn(true);
        let selectedPressListToUpload = [];
        if (scenario == 1 || scenario == 2)
        {
            selectedPressListToUpload.push(newPress);
            for (let i = 0; i < pressListBySeries.length; i++){
                if (pressListBySeries[i].rowConfig.selected === true) {
                    selectedPressListToUpload.push(pressListBySeries[i].idPress);
                }
            }
        }else
        {
            for (let i = 0; i < pressListBySeries.length; i++){
                if (pressListBySeries[i].rowConfig.selected === true) {
                    selectedPressListToUpload.push(pressListBySeries[i].idPress);
                }
            }
        }

        let combineClicksToUpload = [];
        for (let i = 0; i < combineClicksList.length; i++){
            combineClicksToUpload.push(combineClicksList[i].endUserCombineClicks);
        }
        
        let data = new FormData();
        data.append("idSpecialConditionType",specialConditionType);
        data.append("idEndUser",endUser);
        data.append("idCustomer",channel);
        data.append("series",series);
        data.append("endUserContactName",endUserContactName);
        data.append("endUserContactPhone",endUserContactPhone);
        data.append("endUserContactPosition",endUserContactPosition);
        data.append("startDate",(new Date(startDate).getFullYear() + '-' + (new Date(startDate).getMonth() + 1).toString().padStart(2, '0') + '-01'));
        data.append("effectiveMonths",effectiveMonths);
        if((series >= 4) && (specialConditionType === 21))// si es condicion especial 21 y serie 4 o 5 dividimos por su formato y guardamos en porcentaje
            data.append("percentage",((percentage==''?0:percentage)/multiplierConfig)*100);//multiplicamos por 100 porque en el BackEnd lo divide por 100 para guardarlo
        else {
            if ( specialConditionType === 11 ) // Sie es Minimo Discount enviamos el valor porcentual minimo
                data.append("percentage",minumimDiscount);
            else
                data.append("percentage",percentage==''?0:percentage);
        }
        data.append("minimumImp",minimumImp);
        data.append("businessJustification",businessJustification);
        data.append("competition",competition);
        data.append("volumeGrowth",volumeGrowth);
        data.append("businessOpportunities",businessOpportunities);
        data.append("comments",comments);
        data.append("newPress",newPress);
        data.append("newEndUser",newEndUser);
        data.append("opdNumber",opdNumber);
        data.append("createdBy",currentUser.idUser);
        data.append("scenario",scenario);
        data.append("pressList",JSON.stringify(selectedPressListToUpload));
        data.append("compensationTable",JSON.stringify(compensationTable));
        data.append("bonusTable",JSON.stringify(bonusTable));
        data.append("bonusLSDiscountTable",JSON.stringify(bonusLSDiscountSend));
        data.append("combineClicks",JSON.stringify(combineClicksToUpload));
        data.append("confirm","no");
        data.append("MinimumPrint",MinimumPrint);
        
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: 'css-la566w-padding-Button',
              cancelButton: 'css-k95t6a-padding-Button'
            },
            buttonsStyling: false
          })

        const handleUploadFinal = (status, response) => {
            // alert("Special Condition submitted.");
            Swal.fire(
                t('SpConditionSubmitted'),
                "",
                "success"
            );
            clearForm();
            //window.location.reload()
        }
        
        connectApi
        .post(
            "api/Channels/UploadSpecialCondition",
            data,
            handleUploadFinal
        )
        .catch((error) => {
            if(error?.response?.status==512){
                swalWithBootstrapButtons.fire({
                    title: "Warning " + error?.response?.status,
                    html: error?.response?.data+", ",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Create Special Condition',
                    cancelButtonText:'Return and change Dates',
                  }).then((result) => {
                    if (result.isConfirmed) {
                        data.delete("confirm");
                        data.append("confirm","yes");
                        connectApi
                        .post(
                            "api/Channels/UploadSpecialCondition",
                            data,
                            handleUploadFinal
                        )

                    }
                  })
            }else{
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            }
           
            setSubmitBtn(false);
        });
    }

    return(
        <div style={{padding: "0.5%"}}>
            {formStart()}
            {formPressInfo()}

            <Container style={{margin: "16px 0"}}>
                <Row>
                    {showSpConditionTypeList()}
                </Row>
            </Container>

            <Container style={{margin: "16px 0"}}>
                {showFixedBonus()}
                {showMaxCostPerImpression()}
                {showBonusSpecialTable()}
                {showCombineClicks()}
                {showTiersUp()}
                {showMinumimDiscount()}
                {showBonusLSDiscount()}
                {showRunLength()}
            </Container>

            {formBusinessInfo()}
        </div>
    );
}

export default NewSpecialCondition